import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledWhoIsJadeSoft = styled(Box)(({ theme }) => ({

    '& .mainContainer': {
        minHeight: 'calc(100vh - 82px)',
        overflowX: 'hidden',
        justifyContent: 'center',
        // backgroundColor: '#fff',
        background: 'transparent',
        // zIndex: 999,
        width: '100%',
        position: 'relative',
        marginTop: '-10px',
        // zIndex: '999',
        '& .homeBg': {
            position: 'absolute',
            height: '100%',
            width: '100%',
            background: 'fff',

            '& .videoElement': {
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                objectFit: 'cover',
                zIndex: -1,
                padding: '0px 80px 4.2% 80px !important',
                // 
            },

            '& .videoElementGap': {
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                objectFit: 'cover',
                zIndex: -1,
                padding: '5% 4.3% 4.2% 4.3% !important'
            },
        },

        '& .homeContent': {
            position: 'absolute',
            height: '100%',
            width: '100%',
            zIndex: 1 /* Ensures content is above the video */,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            // marginTop: theme.spacing(30),
            // paddingLeft: '20%',
            // padding: '10% 17.7%',
            // padding: '5% 10%',
            background: 'transparent',

            '& .bannerText': {
                background: theme.customGradients.primary,
                '-webkit-background-clip': 'text',
                '-webkit-text-fill-color': 'transparent',
                boxShadow: theme.palette.boxShadow.secondary,
                font: theme.typography.h3.font,
                fontWeight: 400,
                textAlign: 'center',
            },

            [theme.breakpoints.down('lg')]: {
                paddingLeft: 1,
                '& .iconBrandLogo': {
                    width: '300px',
                    height: '100px',
                },
            },
        },

        [theme.breakpoints.down('lg')]: {
            // minHeight: '100vh',
            minHeight: '440px',
            // margin: theme.spacing(0),
            // marginTop: '-23px',
            // paddingTop: 30,

            '& .homeContent': {
                marginTop: theme.spacing(0),
                marginBottom: theme.spacing(0),
                justifyContent: 'center',
                // bottom: '152px',
                // padding: '0 10px',
                padding: '0',

                '& .bannerText': {
                    margin: theme.spacing(0, 1),
                    font: theme.typography.h6.font,
                    fontWeight: `${500} !important`,
                },
            },
            '& .homeBg': {
                '& .videoElementGap': {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    objectFit: 'none',
                    zIndex: -1,
                    padding: '10% 4% 4.2% 4% !important',
                    '@media (min-width: 768px)': {
                        padding: '10% 1.8% 4.2% 1.8% !important',
                    },
                },
                '& .videoElement': {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    objectFit: 'none',
                    zIndex: -1,
                    padding: '0% 4% 4.2% 4% !important',
                    '@media (min-width: 768px)': {
                        padding: '0% 1.8% 4.2% 1.8% !important',
                    },
                },
            }
        },
    },

    '& .content': {
        // backgroundColor: '#fff',
        background: 'transparent',
        paddingBottom: '20px',
        '& .MuiTypography-root': {
            margin: '0px',
            fontSize: '18.7px',
            fontWeight: '600',
            color: '#252525',
        }
    }

}));

export default StyledWhoIsJadeSoft;
